import { render, staticRenderFns } from "./opposing_team_search_result.vue?vue&type=template&id=55708b8e&"
import script from "./opposing_team_search_result.vue?vue&type=script&lang=js&"
export * from "./opposing_team_search_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports